import Wprr from "wprr";
import React from "react";

import SinglePositionMap from "./SinglePositionMap.js";

export default class Map extends Wprr.BaseObject {
	
	_construct() {
		super._construct();
	}

	_renderMainElement() {
		
		let mobileLayout = <div className="ratio-4-3 full-width">
			<SinglePositionMap className="full-size full-width" latitude={52.706620284169205} longitude={-2.8822905736266593} />
		</div>;
		
		
		let desktopLayout = <div className="ratio-3-1">
			<SinglePositionMap className="full-size" latitude={52.706620284169205} longitude={-2.8822905736266593}  />
		</div>;
		
		let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
		responsiveLayout.addResponsiveTemplate(desktopLayout, 860);
		
		return <React.Fragment>
			{responsiveLayout.getReactElements()}
		</React.Fragment>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>
				
			</div>
		</Wprr.layout.admin.WpBlockEditor>;
	}
}